//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default{
	props: {
		detail: {
			type: Object,
		},
		state:{
			type: String,
		}
	},
	data() {
		return {
			list:[], //游客评论的列表
			commentDetail:'', //评论的内容
			showCommentInput: false, //
			commentItem: {isOrigin: 1},
			userId: '',
			isCommentShow:false
		}
	},
	// components: {
	// 	uniIcon
	// },
	mounted(){
		this.userId = this.$store.state.userInfo.memberId
		this.queryData()
	},
	methods: {
		//时间的格式转化
		getDate (time) {
			let date = new Date(time)
			let minu = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			// let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			// let dates = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			// return month + '-' + dates
			return date.getMonth() + 1 + '月' + date.getDate() + '日' + ' ' + date.getHours() + ':' + minu
		},
		//内容的转化
		escape2Html (str) {
			let arrEntities = {'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"'}
			return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) { return arrEntities[t] })
		},
		//清空发布内容
		clearContent(){
			this.commentDetail = ''
		},
		//发布评论的内容
		comment(e){
			this.commentDetail = e.target.value
		},
		//回复
		reply (item, isOrigin) {
			this.commentItem = JSON.parse(JSON.stringify(item))
			this.commentItem.reply_nickname = this.commentItem.nickname ? this.commentItem.nickname : ''
			this.commentItem.isOrigin = isOrigin
			this.showCommentInput = true
			this.isCommentShow = true
		},
		//删除评论
		del(item){
			let _this = this
			this.$ajax({
				method:'post',
				url:'/weChat/cms/reviewmanagement/delete',
				data:{
					id:item.id
				}
			}).then(res=>{
				_this.queryData()
				_this.showCommentInput = false
				_this.commentDetail = ''
				uni.showToast({
					title:'删除成功',
					icon:'none'
				})
			})
		},
		//发布评论
		commentEnd(){
			let _this = this
			if (this.commentDetail && !!this.userId) {
				this.commentDetail = this.escape2Html(this.commentDetail)
				this.$ajax({
					method:'post',
					url:'/weChat/cms/reviewmanagement/add',
					data:{
						replyContent: this.commentDetail,
						userId: this.userId,
						messageId: this.detail.id,
						replyId: this.commentItem.isOrigin ? '' : this.commentItem.id,
						messageType: this.state
					}
				}).then(res=>{
					_this.queryData()
					_this.showCommentInput = false
					_this.commentDetail = ''
					this.isCommentShow = false
					uni.showToast({
						title:'评论发送成功',
						icon:'none'
					})
				})
			}
		},
		//获取评论列表
		queryData() {
			let _this = this
			this.$ajax({
				method:'post',
				url:'/weChat/cms/reviewmanagement/queryByContation',
				data:{
					messageId: this.detail.id,
					currentPage: 1,
					pageSize: 999
				}
			}).then(res=>{
				_this.list = res.data.map(t => {
					return {
						...t,
						nickname: decodeURI(t.nickName),
						replyContent: _this.escape2Html(t.replyContent),
						reply_nickname: decodeURI(t.replynickName)
					}
				})
			})
		},
		initComment () {
			this.commentItem.isOrigin = true
			this.commentItem.reply_nickname = ''
			this.isCommentShow = true
		}
	},
}
